<ngx-intl-tel-input
  [formControl]="formControl"
  [cssClass]="
    (formControl.invalid && (formControl['touched'] && formControl.dirty))
      ? (modal ? 'modal-class !border-red-500' : 'page-class !border-red-500')
      : (modal ? 'modal-class' : 'page-class')
  "
  pInvalidOnError
  [preferredCountries]="preferredCountries"
  [enableAutoCountrySelect]="true"
  [enablePlaceholder]="true"
  [searchCountryFlag]="true"
  [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
  [selectFirstCountry]="false"
  [selectedCountryISO]="handleCountryCode(selectedCountryISO)"
  [maxLength]="15"
  [phoneValidation]="true"
  [separateDialCode]="true"
  [numberFormat]="PhoneNumberFormat.National"
  [disabled]="disabled"
/>
@if (formControl.invalid && (formControl['touched'] && formControl.dirty)) {
  <app-error [control]="formControl" [customErrorMessage]="'Invalid Phone Number'"/>
}

